/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_CopyInputs */

const en_salary_negotiate_copy = /** @type {(inputs: Salary_Negotiate_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const de_salary_negotiate_copy = /** @type {(inputs: Salary_Negotiate_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren`)
};

const fr_salary_negotiate_copy = /** @type {(inputs: Salary_Negotiate_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier`)
};

const es_salary_negotiate_copy = /** @type {(inputs: Salary_Negotiate_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const it_salary_negotiate_copy = /** @type {(inputs: Salary_Negotiate_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia`)
};

const nl_salary_negotiate_copy = /** @type {(inputs: Salary_Negotiate_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiëren`)
};

const pl_salary_negotiate_copy = /** @type {(inputs: Salary_Negotiate_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiuj`)
};

const fi_salary_negotiate_copy = /** @type {(inputs: Salary_Negotiate_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopioi`)
};

const da_salary_negotiate_copy = /** @type {(inputs: Salary_Negotiate_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopier`)
};

const sv_salary_negotiate_copy = /** @type {(inputs: Salary_Negotiate_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiera`)
};

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Salary_Negotiate_CopyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_copy = /** @type {((inputs?: Salary_Negotiate_CopyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_CopyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_copy(inputs)
	if (locale === "fr") return fr_salary_negotiate_copy(inputs)
	if (locale === "es") return es_salary_negotiate_copy(inputs)
	if (locale === "it") return it_salary_negotiate_copy(inputs)
	if (locale === "nl") return nl_salary_negotiate_copy(inputs)
	if (locale === "pl") return pl_salary_negotiate_copy(inputs)
	if (locale === "fi") return fi_salary_negotiate_copy(inputs)
	if (locale === "da") return da_salary_negotiate_copy(inputs)
	if (locale === "sv") return sv_salary_negotiate_copy(inputs)
	return en_salary_negotiate_copy(inputs)
});